import React from "react";
import ImageView from "../../../components/SmartImage";
import { TBannerItem } from "../../../services/banner";
import { StickBottomContainer } from "./styles";

export interface StickBottomTabProps {
  positionId: string;
  images: TBannerItem[];
  bgColor: string;
  placeholderBg?: string;
}

const MStickBottomTab = (props: StickBottomTabProps) => {
  const { positionId, images, bgColor, placeholderBg } = props;
  return (
    <section id={positionId}>
      <StickBottomContainer bgColor={bgColor}>
        {images.map((ele, index) => {
          return (
            <a key={`${index}${ele.link}`} href={ele.link}>
              <ImageView
                src={ele.img}
                online={true}
                placeholder={placeholderBg}
                fallbackSrc={placeholderBg}
                alt=""
              />
            </a>
          );
        })}
      </StickBottomContainer>
    </section>
  );
};

export default MStickBottomTab;
